import { jsx as _jsx } from "react/jsx-runtime";
import { ParameterAndColorSelection } from './parameter-color-selection';
export const ChangeGraphDialogItem = (props) => {
    const { item, group_name, selectedSource, get_name_source_for_selected, update_item_color, update_item_checkbox, } = props;
    const name_item = get_name_source_for_selected(item);
    const check = selectedSource[group_name]?.[name_item]?.checked;
    const label = item.title().toString();
    const item_color = selectedSource[group_name]?.[name_item]?.color;
    return (_jsx(ParameterAndColorSelection, { label_item: label, name_item: name_item, group: group_name, item: item, color_item: item_color, check_item: check, update_item_check: update_item_checkbox, update_item_color: update_item_color }, name_item));
};
